import _ from "lodash";
import removeDuplicates from "../../../src/views/filiation/removeDuplicates";

export const segipResponse = (state, { data }) => {
  if (data != "No existe información") {
    state.status = "extracted";
    state.segipResponse = data;
  } else {
    state.status = "No information";
    state.segipResponse = null;
  }
};
export const listProvinces = (state, { data }) => {
  state.listProvinces = data;
};
export const listMunicipalities = (state, { data }) => {
  state.listProvinces = data;
};
export const listPrivatedLibertyPersons = (state, { data }) => {
  state.listPrivatedLibertyPersons = data;
};
export const countPersonsCenter = (state, { data }) => {
  state.countPersonsCenter = data;
};
export const countGenrePersonsCenter = (state, { data }) => {
  state.countGenrePersonsCenter = data;
};
export const countPersonsLegalStatus = (state, { data }) => {
  state.countPersonsLegalStatus = data;
};
export const countPersonsByDepartment = (state, { data }) => {
  state.countPersonsByDepartment = data;
};
export const dataEdit = (state, { data }) => {
  state.statusEdit = "editing";
  state.dataToEdit = data;
};
export const resetStatusEdit = (state) => {
  state.statusEdit = "not editing";
  state.dataToEdit = null;
};
export const personalData = (state, { data }) => {
  state.personalData = data;
};
export const posibleOrder = (state, { data }) => {
  state.posibleOrder = data;
};
export const dataChecked = (state, { data }) => {
  data === null
    ? (state.dataChecked = data)
    : (state.dataChecked = data.result);
};
export const chartData = (state, { data }) => {
  state.chartData = data;
  state.chartDataTwoParams = null;
  state.chartStatus = "one";
};
export const chartDataTwoParams = (state, { data }) => {
  const dataResult = [];
  for (let dato of data[0].primer) {
    const result = data[1].segundo.filter((i) => i.data1 == dato.nombre);
    dataResult.push(result);
  }

  let auxArray = [];
  dataResult.forEach((element) => {
    var grouped = _.groupBy(element, function (val) {
      return val.data1;
    });
    auxArray.push(grouped);
  });

  let finalArray = [];
  for (let index = 0; index < auxArray.length; index++) {
    const elementDos = auxArray[index];
    const [objectKey] = Object.keys(elementDos);
    const [data] = Object.values(elementDos);
    let finalObj = { nombre: objectKey };
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      let { data2, count } = element;
      finalObj = { ...finalObj, [data2]: Number(count) };
    }
    finalArray.push(finalObj);
  }
  var uniqueArray = removeDuplicates(data[1].segundo, "data2");
  state.chartDataTwoParams = {
    data1: finalArray,
    data2: uniqueArray,
    dataBars: data[1].segundo,
  };
  state.chartData = null;
  state.chartStatus = "two";
};
